const wrapperLoadMore = document.querySelector('.contributors-load-more');
const btnLoadMore = document.querySelector('.contributors-load-more button');
const cards = document.querySelectorAll('.contributor-card');
const contributors = [];
const descriptions = document.querySelectorAll('.contributor-descriptions');
const filterSelect = document.querySelector('.js-filter-select');
const noResultsBox = document.querySelector('.contributors-no-results');
const searchBar = document.getElementById('contributor-search');
const showCards = 16;
let btnLoadMoreClicked = false;
let filteredByType = [];
let filteredBySearch = [];
let filtered = [];

/**
 * Contributors array
 */
cards.forEach((card) => {
  contributors.push({
    id: card.dataset.id,
    name: card.dataset.name,
    career: card.dataset.career,
    subject: card.dataset.subject,
    writer: card.dataset.writer,
    editor: card.dataset.editor,
    reviewer: card.dataset.reviewer,
  });
});

function hideExtraCards() {
  // reset loadMoreButton
  wrapperLoadMore.classList.add('hidden');

  // counts cards over the showCards max limit set
  let currentVisible = 0;
  cards.forEach((card) => {
    // reset all cards's hiddenLoadMore status
    card.classList.remove('hiddenLoadMore');
    if (card.classList.contains('active')) {
      currentVisible += 1;
    }

    // hides extra cards over the limit
    if (currentVisible > showCards) {
      card.classList.add('hiddenLoadMore');
      // shows button if applicable
      wrapperLoadMore.classList.remove('hidden');
    }
  });
}

function handleContributors() {
  // mixes common results (by id) if both filters have data, or
  // sets whichever of the filters is active
  filtered = [];
  if (filteredByType.length && filteredBySearch.length) {
    filtered = filteredBySearch.filter((fs) => filteredByType.some((ft) => fs.id === ft.id));
  } else if (filteredByType.length && !filteredBySearch.length && searchBar.value.length) {
    filtered = [];
  } else if ((filteredByType.length || filteredBySearch.length)) {
    filtered = filteredByType.length ? filteredByType : filteredBySearch;
  }

  if (!filtered.length && !searchBar.value.length) {
    // Make all cards visible when there's no filters and search is empty
    cards.forEach((card) => card.classList.add('active'));
  } else {
    cards.forEach((card) => {
      // unhide if this card's id is in any of the filtered array
      if (filtered.find((record) => record.id === card.dataset.id)) {
        card.classList.add('active');
      } else {
        card.classList.remove('active');
      }
    });
  }

  // handles noResultsBox error display
  if (!filteredBySearch.length && searchBar.value.length) {
    noResultsBox.classList.remove('hidden');
  } else {
    noResultsBox.classList.add('hidden');
  }

  // if loadMore hasn't been activated
  if (!btnLoadMoreClicked) {
    hideExtraCards();
  }
}

function filterContributorsBySearch(searchTerm) {
  return searchTerm.length
    ? contributors.filter((contributor) => (
      contributor.name.toLowerCase().includes(searchTerm)
      || contributor.career.toLowerCase().includes(searchTerm)
      || contributor.subject.toLowerCase().includes(searchTerm)
    ))
    : [];
}

function filterContributorsByType(type) {
  return type.length
    ? contributors.filter((contributor) => contributor[type] === 'true')
    : [];
}

/**
 * EVENT CLICKS
 */

/**
 * Handles nav bar click logic
 */
filterSelect.addEventListener('change', () => {
  // resets search
  searchBar.value = '';
  filteredBySearch = [];

  // stores clicked value
  const selectedContributors = filterSelect.value;

  // toggles description to active one
  descriptions.forEach((eachDescription) => {
    if (eachDescription.dataset.description === selectedContributors) {
      eachDescription.classList.remove('hidden');
    } else {
      eachDescription.classList.add('hidden');
    }
  });

  filteredByType = filterContributorsByType(selectedContributors);
  handleContributors();
});

/**
 * Handles search field logic
 */
searchBar.addEventListener('keyup', (e) => {
  const searchString = e.target.value.toLowerCase();
  filteredBySearch = filterContributorsBySearch(searchString);
  handleContributors();
});

/**
 * Handles More button
 */
btnLoadMore.addEventListener('click', () => {
  cards.forEach((card) => card.classList.remove('hiddenLoadMore'));
  wrapperLoadMore.classList.add('hidden');
  btnLoadMoreClicked = true;
  const activeContributors = document.querySelector('.js-contributor-cards').querySelectorAll('.active');

  // if no filters are applied OR filters are applied and there are more than 16 contributors,
  // this selects the first newly revealed contributor to be the next focus
  if (!filtered.length || (filtered.length > showCards && activeContributors.length > 16)) {
    const nextContributor = activeContributors[showCards].querySelector('.contributor-link');
    nextContributor.focus();
  }
});

handleContributors();
